import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleArrowDown.svg",
  "use": "CircleArrowDown.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleArrowDown.svg\"><path d=\"M8,32A24,24,0,1,1,32,56,24,24,0,0,1,8,32Zm44,0A20.001,20.001,0,0,0,34,12.1009v25.071l7.5729-7.5871a2.0016,2.0016,0,0,1,2.829,2.8324L33.3976,43.44a1.9985,1.9985,0,0,1-2.8291,0L19.5641,32.4172a2.0016,2.0016,0,0,1,2.829-2.8324L30,37.2058V12.1009A20,20,0,1,0,52,32Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol